<!--  -->
<template>
  <section class="promo-tip">
    <span class="icon pf-medium">¥</span>
    <span class="price pf-medium" v-html="price"></span>
    <span class="line pf-medium" v-if="moreCmmdtySpecs">起</span>
    <div class="tips" v-if="!showShareEarn">
      <span class="subtitle pt2">{{ mixInfo.buyNowSubtitle }}</span>
      <span class="t-icon pf-medium pt4">¥</span>
      <span class="t-price pf-medium">{{ mixInfo.minPrice }}</span>
      <span class="t-line pt2" v-if="moreCmmdtySpecs">起</span>
    </div>
  </section>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import mixProm from '@/mixin/mixProm'
import { mapState } from 'vuex'
import { showShareEarnInProductDetail } from '@/router/home/utils'
export default {
  //import引入的组件需要注入到对象中才能使用
  mixins: [mixProm],
  components: {},
  data() {
    //这里存放数据
    return {}
  },
  //监听属性 类似于data概念
  computed: {
    ...mapState([
      'product',
      'viewName',
      'comments',
      'commentCount',
      'selectedWorker',
      'selectedAddress',
      'selectedTime',
      'locationInfo',
      'selectedSku',
      'isMinProgram',
      'otherServiceDatas'
    ]),
    ...mapState('promotionInfo', {
      promotionInfo: state => state.promotionInfo
    }),
    price() {
      if (this.selectedSku && this.selectedSku.skuId) {
        return `${
          (this.selectedSku.customerPrice != null
            ? this.selectedSku.customerPrice
            : this.selectedSku.price) / 100
        }`
      } else {
        return `${
          (this.product.minCustomerPrice != null
            ? this.product.minCustomerPrice
            : this.product.minPrice) / 100
        }`
      }
    },
    showShareEarn() {
      return showShareEarnInProductDetail()
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';

.promo-tip {
  display: flex;
  align-items: center;
  .icon {
    line-height: rem(27px);
    font-size: rem(26px);
    color: #ff5900;
    position: relative;
    top: rem(6px);
  }
  .price {
    line-height: rem(48px);
    font-size: rem(48px);
    color: #ff5900;
  }
  .line {
    position: relative;
    top: rem(4px);
    margin-left: rem(4px);
    font-size: rem(26px);
    color: #ff5900;
    letter-spacing: 0;
  }
  .tips {
    padding: 0 rem(14px);
    height: rem(48px);
    color: #ffffff;
    display: flex;
    align-items: center;
    // height: rem(48px);
    background-image: linear-gradient(90deg, #ff8800 0%, #ff5900 100%);
    border-radius: rem(100px);
    margin-left: rem(8px);
    .subtitle {
      display: inline-block;
      font-size: rem(24px);
      margin-right: rem(4px);
    }
    .t-icon {
      margin-right: rem(2px);
      font-size: rem(24px);
      color: #fff;
    }
    .t-price {
      line-height: 1;
      font-size: rem(36px);
      color: #ffffff;
    }
    .t-line {
      font-size: rem(24px);
      color: #ffffff;
      margin-left: rem(2px);
    }
  }
}
</style>
